import templateStr from 'text!./templates/pa-edit-coverages.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            model: '=gwPcPaEditCoverages',
            onCovChange: '=',
            onAdditionalCovChange: '=',
            loading: '=?'
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/pa/directives/PAEditCoverages.js
// module id = 1194
// module chunks = 0